import { NodeSelection } from 'prosemirror-state';
import { equalNodeType } from './helper';
export const findParentNodeClosestToPos = (predicate) => ($pos) => {
    for (let i = $pos.depth; i > 0; i--) {
        const node = $pos.node(i);
        if (predicate(node)) {
            return {
                pos: i > 0 ? $pos.before(i) : 0,
                start: $pos.start(i),
                depth: i,
                node,
            };
        }
    }
    return;
};
export const findParentNode = (predicate) => (selection) => {
    return findParentNodeClosestToPos(predicate)(selection.$from);
};
export const findSelectedNodeOfType = (selection, nodeType) => {
    if (!(selection instanceof NodeSelection)) {
        return;
    }
    const { node, $from } = selection;
    if (equalNodeType(nodeType, node)) {
        return { node, pos: $from.pos, start: $from.start($from.depth), depth: $from.depth };
    }
    return undefined;
};
//# sourceMappingURL=selection.js.map